import { buildUrlFromLocation } from "@/utils/httpUtils";
import http from "@/services/http";
import cacheService from "@/services/cache";

export default {
    async getBrand(brandId) {
        return await http.get(buildUrlFromLocation(`/admin/brands/${brandId}`, { campaignId: null }));
    },
    async getZoneRelationType() {
        return await http.get(buildUrlFromLocation(`/admin/zone-relation-types`, { campaignId: null }));
    },
    getAll() {
        const user = cacheService.getRem3rchUser();
        return (user && user.user && user.user.brands) || [];
    },
    async updateBrand(brand) {
        return await http.put(`/admin/brands/${brand.id}`, brand);
    },
    async updatePartially(updatedBrand) {
        return await http.patch(buildUrlFromLocation(`/admin/brands`, { campaignId: null }), updatedBrand);
    },
    async createBrand(brand) {
        return await http.post(`/admin/brands`, brand);
    },
    async getBrandApplications(brandId) {
        return await http.get(buildUrlFromLocation(`/admin/brands/${brandId}/applications`, { campaignId: null }));
    }
};



// WEBPACK FOOTER //
// ./src/services/brand.js